import { Injectable } from '@angular/core';
import { UserProfileService } from '../../../features/user-profile/user-profile.service';
// import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {

  public SESSION_KEY = 'USER_INFO';
  private userId = '';

  constructor(private userProfileService: UserProfileService) {}

  public setUserSession(sessionKey, userInfo) {
    localStorage.setItem(sessionKey, userInfo);
  }

  public getUserSession() {
    return localStorage.getItem(this.SESSION_KEY);
  }

  public getUserName(): string {
    if (this.getUserSession()) {
      const userInfo = JSON.parse(this.getUserSession());
      this.userId = userInfo['username'].toUpperCase();
    }
    return this.userId;
  }

  public getUserEmail() {
    const userEmail = this.userProfileService.getUsersInfoById(this.userId).subscribe(userData => {
      return userData['email'];
    });
  }

  public isAuthenticated(): boolean {
    // let userInfo = this.getUserSession();
    if (this.getUserSession()) {
      // userInfo = JSON.parse(this.getUserSession());
      // const userType = userInfo['userType']['userTypeName'];
      return true;
    }
    return false;
  }

}
